module.exports = __webpack_public_path__ + "img/thaipost_logo.52ea6bc6.png";